(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    class CollectionFilters {
    constructor(container) {
      this.container = container;
      this.filterToggle = container.querySelector('[data-filter-toggle]');
      this.filterContainer = container.querySelector('[data-filter-container]');
      this.filterOverlay = container.querySelector('[data-filter-overlay]');
      this.closeButton = container.querySelector('[data-filter-close]');
      this.form = container.querySelector('[data-filter-form]');
      this.sortDropdown = container.querySelector('[data-sort-dropdown]');
      this.sortToggle = container.querySelector('[data-sort-toggle]');
      
      this.layout = container.closest('[data-collection-layout]');
      this.desktopQuery = window.matchMedia('(min-width: 1024px)');
      this.desktopQuery.addEventListener('change', () => this.close());
      if (this.layout && container.dataset.desktopFilterLayout === 'sticky') {
        const updateOffsets = () => {
          const header = document.querySelector('[data-header]');
          const headerHeight = header?.closest('.shopify-section')?.getBoundingClientRect().height || header?.getBoundingClientRect().height || 73;
          const toolbarHeight = container.querySelector('.filter-toolbar')?.offsetHeight || 56;
          this.sidebarOffset = headerHeight + toolbarHeight + 16;
          this.layout.style.setProperty('--collection-header-offset', `${headerHeight}px`);
          this.layout.style.setProperty('--collection-sidebar-offset', `${this.sidebarOffset}px`);
          this.updateSidebarHeight();
        };
        this.resizeObserver = new ResizeObserver(updateOffsets);
        const header = document.querySelector('[data-header]');
        if (header) this.resizeObserver.observe(header);
        this.resizeObserver.observe(container.querySelector('.filter-toolbar'));
        let heightUpdatePending = false;
        const scheduleHeightUpdate = () => {
          if (heightUpdatePending) return;
          heightUpdatePending = true;
          requestAnimationFrame(() => {
            heightUpdatePending = false;
            this.updateSidebarHeight();
          });
        };
        window.addEventListener('scroll', scheduleHeightUpdate, { passive: true });
        window.addEventListener('resize', scheduleHeightUpdate);
        updateOffsets();
      }
      this.init();
      if (this.isStickyDesktop() && container.dataset.hasActiveFilters === 'true') {
        this.open();
      }
    }

    init() {
      // Toggle filter panel
      this.filterToggle?.addEventListener('click', () => this.isOpen() ? this.close() : this.open());
      this.updatePaginatedSizeCounts();

      // Close button
      this.closeButton?.addEventListener('click', () => this.close());

      // Close on overlay click
      this.filterOverlay?.addEventListener('click', () => this.close());

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' && this.isOpen() && !this.isStickyDesktop()) {
          const focusable = Array.from(this.filterContainer.querySelectorAll('a[href], button, input, summary, [tabindex="0"]'))
            .filter(element => !element.disabled && element.getClientRects().length);
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last?.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first?.focus();
          }
        }
        if (e.key === 'Escape') {
          if (this.isOpen()) {
            this.close();
          }
          if (this.sortDropdown?.classList.contains('active')) {
            this.sortDropdown.classList.remove('active');
            this.sortToggle?.setAttribute('aria-expanded', 'false');
          }
        }
      });

      // Sort dropdown toggle
      this.sortToggle?.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = this.sortDropdown.classList.toggle('active');
        this.sortToggle.setAttribute('aria-expanded', String(isOpen));
      });

      // Close sort dropdown on outside click
      document.addEventListener('click', (e) => {
        if (this.sortDropdown?.classList.contains('active') && 
            !this.sortDropdown.contains(e.target)) {
          this.sortDropdown.classList.remove('active');
          this.sortToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    isStickyDesktop() {
      return this.container.dataset.desktopFilterLayout === 'sticky' && this.desktopQuery.matches && Boolean(this.layout);
    }

    updateSidebarHeight() {
      if (!this.isStickyDesktop() || !this.isOpen()) return;
      const top = Math.max(this.sidebarOffset || 145, this.filterContainer.getBoundingClientRect().top);
      const height = Math.max(0, window.innerHeight - top - 16);
      this.filterContainer.style.setProperty('--collection-sidebar-height', `${height}px`);
    }

    open() {
      this.filterContainer.inert = false;
      this.filterContainer.classList.add('active');
      this.filterToggle.setAttribute('aria-expanded', 'true');
      if (this.isStickyDesktop()) {
        this.layout.dataset.sidebarOpen = 'true';
        this.updateSidebarHeight();
        return;
      }
      this.filterContainer.setAttribute('role', 'dialog');
      this.filterContainer.setAttribute('aria-modal', 'true');
      this.filterOverlay.classList.add('active');
      this.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      const stickyFilter = this.container.closest('[data-sticky-filter]');
      if (stickyFilter) stickyFilter.style.zIndex = '50';
      this.closeButton?.focus();
    }

    close() {
      const wasOpen = this.isOpen();
      const wasModal = this.filterContainer.hasAttribute('aria-modal');
      this.filterContainer.classList.remove('active');
      this.filterContainer.inert = true;
      this.filterContainer.removeAttribute('role');
      this.filterContainer.removeAttribute('aria-modal');
      this.filterOverlay.classList.remove('active');
      this.filterToggle.setAttribute('aria-expanded', 'false');
      if (this.layout) this.layout.dataset.sidebarOpen = 'false';
      if (wasModal) document.body.style.overflow = this.previousOverflow || '';
      const stickyFilter = this.container.closest('[data-sticky-filter]');
      if (stickyFilter) stickyFilter.style.zIndex = '10';
      if (wasOpen) this.filterToggle.focus();
    }

    isOpen() {
      return this.filterContainer.classList.contains('active');
    }

    parseSizeCounts(rawCounts) {
      return String(rawCounts || '').split('||').reduce((counts, token) => {
        if (!token) return counts;
        const parts = token.split('::');
        if (parts.length < 3) return counts;
        const key = `${parts[0]}::${parts[1]}`;
        const value = Number.parseInt(parts[2], 10);
        counts[key] = (counts[key] || 0) + (Number.isFinite(value) ? value : 0);
        return counts;
      }, {});
    }

    getPageUrl(page) {
      const url = new URL(window.location.href);
      url.searchParams.set('page', String(page));
      return url.toString();
    }

    applySizeCounts(counts) {
      this.container.querySelectorAll('[data-size-filter-count]').forEach((countEl) => {
        const key = countEl.dataset.sizeFilterCount;
        const count = counts[key] || 0;
        countEl.textContent = `(${count})`;
      });

      this.container.querySelectorAll('[data-size-filter-input]').forEach((input) => {
        const key = input.dataset.sizeFilterInput;
        const count = counts[key] || 0;
        const shouldDisable = count === 0 && !input.checked;
        const label = input.labels && input.labels.length ? input.labels[0] : null;

        input.disabled = shouldDisable;
        if (label) {
          label.classList.toggle('opacity-50', shouldDisable);
          label.classList.toggle('cursor-not-allowed', shouldDisable);
        }
      });
    }

    applyResultCount(count) {
      const countEl = this.container.querySelector('[data-result-count-value]');
      const countLabel = this.container.querySelector('[data-result-count-label]');
      if (countEl) countEl.textContent = String(count);
      if (countLabel) {
        countLabel.textContent = count === 1
          ? countLabel.parentElement.dataset.resultCountSingular
          : countLabel.parentElement.dataset.resultCountPlural;
      }
    }

    renderSizePage(products, page) {
      const pageSize = Number(this.container.dataset.sizeFilterPageSize);
      const pages = Math.max(1, Math.ceil(products.length / pageSize));
      const currentPage = Math.min(Math.max(1, page), pages);
      const grid = this.layout.querySelector('[data-product-grid]');
      const pagination = this.layout.querySelector('[data-size-filter-pagination]');
      grid.replaceChildren(...products.slice((currentPage - 1) * pageSize, currentPage * pageSize));
      this.layout.querySelector('[data-size-filter-empty]').hidden = products.length > 0;
      pagination.replaceChildren();
      if (pages > 1) {
        const nav = document.createElement('nav');
        nav.className = 'mt-16 flex flex-wrap items-center justify-center gap-2 pagination';
        nav.setAttribute('aria-label', pagination.dataset.paginationLabel);
        const addLink = (number, text, label) => {
          const link = document.createElement('a');
          link.href = this.getPageUrl(number);
          link.className = 'inline-flex min-h-11 min-w-11 items-center justify-center px-3 focus-visible:outline-2 focus-visible:outline-offset-2';
          link.textContent = text;
          link.setAttribute('aria-label', label);
          link.addEventListener('click', (event) => {
            if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            history.pushState(null, '', link.href);
            this.renderSizePage(products, number);
            grid.setAttribute('tabindex', '-1');
            grid.focus({ preventScroll: true });
            grid.scrollIntoView({ block: 'start', behavior: 'instant' });
          });
          nav.append(link);
        };
        if (currentPage > 1) addLink(currentPage - 1, '‹', pagination.dataset.previousLabel);
        let previousNumber = 0;
        for (let number = 1; number <= pages; number += 1) {
          if (number !== 1 && number !== pages && Math.abs(number - currentPage) > 2) continue;
          if (previousNumber && number > previousNumber + 1) {
            const ellipsis = document.createElement('span');
            ellipsis.textContent = '…';
            ellipsis.setAttribute('aria-hidden', 'true');
            nav.append(ellipsis);
          }
          const label = pagination.dataset.pageLabel.replace('{number}', String(number));
          if (number === currentPage) {
            const current = document.createElement('span');
            current.className = 'inline-flex min-h-11 min-w-11 items-center justify-center underline';
            current.textContent = String(number);
            current.setAttribute('aria-current', 'page');
            current.setAttribute('aria-label', label);
            nav.append(current);
          } else {
            addLink(number, String(number), label);
          }
          previousNumber = number;
        }
        if (currentPage < pages) addLink(currentPage + 1, '›', pagination.dataset.nextLabel);
        pagination.append(nav);
      }
      if (page !== currentPage) history.replaceState(null, '', this.getPageUrl(currentPage));
    }

    async updatePaginatedSizeCounts() {
      const sizeParam = this.container.dataset.sizeFilterParam;
      const discountParam = this.layout?.hasAttribute('data-search-results') ? 'filter.p.m.custom.discount_range' : '';
      const pageSize = Number(this.container.dataset.sizeFilterPageSize);
      if ((!sizeParam && !discountParam) || !pageSize || !this.layout) return;
      const results = this.layout.querySelector('[data-collection-results]');
      const selectedSizes = [...this.container.querySelectorAll('[data-size-filter-input]:checked')]
        .map(input => input.dataset.sizeFilterLabel || input.value);
      const selectedDiscounts = discountParam ? [...this.container.querySelectorAll('[data-discount-filter-input]:checked')].map(input => input.value) : [];
      const needsFiltering = selectedSizes.length > 0 || selectedDiscounts.length > 0;
      const baseUrl = new URL(window.location.href);
      baseUrl.searchParams.delete(sizeParam);
      if (discountParam) baseUrl.searchParams.delete(discountParam);
      baseUrl.searchParams.delete('page');
      const parsePage = (doc) => {
        const filters = doc.querySelector('[data-collection-filters]');
        const grid = doc.querySelector('[data-product-grid]');
        if (!filters || !grid) throw new Error('Incomplete collection response');
        return {
          pages: Number(filters.dataset.sizeFilterPages),
          counts: this.parseSizeCounts(filters.dataset.sizeFilterCounts),
          products: [...grid.children]
        };
      };
      const fetchPage = async (page) => {
        const url = new URL(baseUrl);
        url.searchParams.set('page', String(page));
        const response = await fetch(url.toString(), {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);
        return parsePage(new DOMParser().parseFromString(await response.text(), 'text/html'));
      };
      const emptyState = this.layout.querySelector('[data-size-filter-empty]');
      const wasEmpty = emptyState.hidden;
      if (needsFiltering) emptyState.hidden = true;
      results.setAttribute('aria-busy', 'true');
      try {
        const currentPage = Number(this.container.dataset.sizeFilterPage) || 1;
        const initial = needsFiltering ? await fetchPage(1) : parsePage(document);
        if (!Number.isInteger(initial.pages) || initial.pages < 0) throw new Error('Invalid collection pagination');
        const responses = new Array(Math.max(1, initial.pages));
        const initialPage = needsFiltering ? 1 : currentPage;
        responses[initialPage - 1] = initial;
        const queue = Array.from({ length: initial.pages }, (_, index) => index + 1)
          .filter(page => page !== initialPage);
        await Promise.all(Array.from({ length: Math.min(3, queue.length) }, async () => {
          while (queue.length) {
            const page = queue.shift();
            responses[page - 1] = await fetchPage(page);
          }
        }));
        const totals = {};
        const discountCounts = {};
        const sizeInputs = [...this.container.querySelectorAll('[data-size-filter-input]')];
        const products = [];
        for (const response of responses) {
          if (!discountParam) {
            for (const [key, count] of Object.entries(response.counts)) {
              totals[key] = (totals[key] || 0) + count;
            }
          }
          for (const product of response.products) {
            const availableSizes = (product.dataset.availableSizeValues || '').split('||');
            const matchesSize = !selectedSizes.length || selectedSizes.some(size => availableSizes.includes(size));
            if (discountParam) {
              const data = JSON.parse(product.querySelector('[data-quick-add-product-json]').textContent);
              const variant = data.variants.find(value => String(value.id) === String(data.selectedVariantId)) || data.variants.find(value => value.available) || data.variants[0];
              if (!variant) throw new Error('Missing product price data');
              const price = Number(variant.price);
              const compare = Number(variant.compareAtPrice);
              const discount = compare > price ? `${Math.floor((compare - price) * 100 / compare)}%` : '';
              if (matchesSize && discount) discountCounts[discount] = (discountCounts[discount] || 0) + 1;
              if (selectedDiscounts.length && !selectedDiscounts.includes(discount)) continue;
              for (const input of sizeInputs) {
                if (availableSizes.includes(input.dataset.sizeFilterLabel || input.value)) {
                  const key = input.dataset.sizeFilterInput;
                  totals[key] = (totals[key] || 0) + 1;
                }
              }
            }
            if (matchesSize) {
              if (selectedSizes.length) {
                const dataElement = product.querySelector('[data-quick-add-product-json]');
                const productData = JSON.parse(dataElement.textContent);
                const variant = productData.variants.find(value => value.available &&
                  selectedSizes.includes(value[`option${product.dataset.sizeOptionPosition}`]));
                if (!variant) throw new Error('Missing available size variant');
                const productUrl = new URL(productData.url, window.location.origin);
                productUrl.searchParams.set('variant', String(variant.id));
                productData.url = productUrl.pathname + productUrl.search;
                productData.selectedVariantId = variant.id;
                dataElement.textContent = JSON.stringify(productData);
                product.querySelectorAll('.main-link, .wk-btn').forEach(link => {
                  link.setAttribute('href', productData.url);
                });
              }
              products.push(product);
            }
          }
        }
        this.applySizeCounts(totals);
        if (discountParam) {
          this.container.querySelectorAll('[data-discount-filter-count]').forEach(element => {
            element.textContent = `(${discountCounts[element.dataset.discountFilterCount] || 0})`;
          });
          this.container.querySelectorAll('[data-discount-filter-input]').forEach(input => {
            const disabled = !discountCounts[input.value] && !input.checked;
            input.disabled = disabled;
            input.labels[0]?.classList.toggle('opacity-50', disabled);
            input.labels[0]?.classList.toggle('cursor-not-allowed', disabled);
          });
        }
        this.applyResultCount(products.length);
        if (needsFiltering) {
          this.renderSizePage(products, currentPage);
          window.addEventListener('popstate', () => {
            const url = new URL(window.location.href);
            const page = Number.parseInt(url.searchParams.get('page') || '1', 10) || 1;
            this.renderSizePage(products, page);
          });
        }
      } catch (error) {
        emptyState.hidden = wasEmpty;
        console.error('Unable to update product filter results', error);
      } finally {
        results.removeAttribute('aria-busy');
      }
    }
  }

  // Initialize filters
  document.addEventListener('DOMContentLoaded', () => {
    const filterContainers = document.querySelectorAll('[data-collection-filters]');
    filterContainers.forEach(container => new CollectionFilters(container));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var dialog = document.querySelector('div[role="dialog"]');
    if (!dialog) return;

    var overlay = dialog.querySelector('[data-popup-overlay]');
    var closeButtons = dialog.querySelectorAll('[data-popup-close]');

    // Prevent background scrolling while popup is visible
    function disableScroll() {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    function enableScroll() {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    function closePopup() {
      enableScroll();
      dialog.style.opacity = '0';
      var panel = dialog.querySelector('.relative.z-10');
      if (panel) {
        panel.style.opacity = '0';
        panel.style.transform = 'translateY(20px)';
      }
      if (overlay) overlay.style.opacity = '0';
      // After transition, remove from DOM flow
      window.setTimeout(function () {
        dialog.style.display = 'none';
        dialog.setAttribute('aria-hidden', 'true');
      }, 210);
    }

    if (overlay) overlay.addEventListener('click', closePopup);
    closeButtons.forEach(function (btn) { btn.addEventListener('click', closePopup); });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closePopup();
    });

    // Disable scroll while visible
    disableScroll();
  })();
  } catch(e) { console.error(e); }
})();

})();
